import React, { Fragment, useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { updateAvatar } from '../../CampaignSystem/services/requests'
import Image from 'react-bootstrap/Image'
import ModalBody from 'react-bootstrap/ModalBody'
import ModalHeader from 'react-bootstrap/ModalHeader'
import CampaignButton from '../ActiveButton'
import FormLabel from 'react-bootstrap/FormLabel'
import imageReader from 'Brands/utils/ImageReader'
import generateImage from 'Brands/utils/GenerateImage'
import AuthError from '../../Influencers/influencerComponents/AuthError'
import { useToasts } from 'react-toast-notifications'
import LoaderComponent from '../Loader'
import { BrandContext } from '../../Brands/utils/BrandContext'
import { JazeelContext } from '../../Influencers/utils/JazeelContext'
import i18n from 'i18n'
import { RTL } from 'locales/currentLang'

const ModalContainer = styled(Modal)`
  backdrop-filter: blur(11px);
  font-family: ${props =>
    props.dir === 'true' ? 'Tajawal !important;' : 'Montserrat !important;'};
  .modal-content {
    border-radius: 20px;
    box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
    border: 0;
    text-align: center;
  }
  .modal-header .close {
    margin: ${props =>
      props.dir === 'true'
        ? '-1rem auto -1rem -1rem;'
        : '-1rem -1rem -1rem auto;'};
  }
`
const Header = styled(ModalHeader)`
  color: #212529;
  font-size: 1em;
  letter-spacing: 0;
  line-height: 1.2em;
  text-align: center;
  border-bottom: 0;
  font-weight: 600;
`
const AvatarImage = styled(Image)`
  width: 7.5em;
  height: 7.5em;
  margin: auto;
  border: 1px solid #dddd;
  border-radius: 50%;
  transition: 0.4s ease-in;
  cursor: pointer;
`
const Footer = styled(Modal.Footer)`
  border: 0;
  justify-content: center;
  padding: 0;
`
const Dismiss = styled.a`
  color: #212529;
  font-size: 0.813em;
  font-weight: 400;
  line-height: 1em;
  display: block;
  width: 100%;
  text-align: center;
  padding-bottom: 1.5em;
`
const UploadButton = styled.input`
  display: none;
`
export default function AvatarModal(props) {
  const { onHide, avatar, type } = props
  const [image, setImage] = useState(avatar)
  useEffect(() => {
    setImage(avatar)
  }, [avatar])
  const [avatarImage, setAvatarImage] = useState(null)
  const [imageError, setImageError] = useState(null)
  const [load, setLoad] = useState(false)
  const { setBrandData, brandData } = useContext(BrandContext)
  const { setUserData, userData } = useContext(JazeelContext)
  const { addToast } = useToasts()
  const validate = () => {
    return avatarImage && avatarImage !== avatar && imageError === null
  }
  const success = () => onHide()
  const stopLoader = () => setLoad(false)
  const onFileChange = async e => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0]
      const size = file.size / 1024 / 1024
      if (size <= 2) {
        let imageDataUrl = await imageReader(file)
        setImage(imageDataUrl)
        const avatar = generateImage(imageDataUrl, file.name)
        setAvatarImage(avatar)
        setImageError(null)
      } else {
        setImageError(i18n.t('errors.image-exceed'))
      }
    }
  }
  const updateImage = e => {
    setLoad(true)
    const avatar = new FormData()
    avatar.append('user_image', avatarImage)
    updateAvatar(
      avatar,
      success,
      addToast,
      setImageError,
      stopLoader,
      type === 'brand' ? setBrandData : setUserData,
      type === 'brand' ? brandData : userData,
    )
  }
  return (
    <Fragment>
      <ModalContainer
        {...props}
        dialogClassName="border-radius-2"
        centered
        backdrop={false}
        dir={RTL().toLocaleString()}
      >
        <Header closeButton>{i18n.t('modal.avatar.hint')}</Header>
        <ModalBody>
          {imageError ? <AuthError error={imageError} /> : null}
          <UploadButton
            type="file"
            accept="image/*"
            id="file-input"
            image={image}
            onChange={onFileChange}
          />
          <FormLabel htmlFor="file-input">
            <AvatarImage src={image} fluid />
          </FormLabel>
        </ModalBody>
        <Footer>
          <LoaderComponent
            visible={load}
            type="ThreeDots"
            height={25}
            width={25}
            color="blue"
            top="-2vh"
            bottom="0"
            isAbsolute={true}
          />
          <CampaignButton
            background="linear-gradient(45deg, #11BED3 0%, #9CDF61 100%)"
            text={i18n.t('modal.avatar.conf')}
            borderRadius="5px"
            textColor="#ffffff"
            textSize="0.875em"
            width="13.313em"
            height="2.750em"
            handleSubmit={updateImage}
            disabled={!validate() || load}
          />
          <Dismiss onClick={() => onHide()}>
            {i18n.t('modal.avatar.review')}
          </Dismiss>
        </Footer>
      </ModalContainer>
    </Fragment>
  )
}

AvatarModal.propTypes = {
  onHide: PropTypes.func,
  avatar: PropTypes.string,
  type: PropTypes.string,
}
